import { render } from "./AppointmentEditModal.vue?vue&type=template&id=fec85b30&scoped=true"
import script from "./AppointmentEditModal.vue?vue&type=script&lang=js"
export * from "./AppointmentEditModal.vue?vue&type=script&lang=js"

import "./AppointmentEditModal.vue?vue&type=style&index=0&id=fec85b30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec85b30"]])

export default __exports__